<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="450" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Ubah Data Pelanggan</v-card-title>
				<v-card-text>
					<v-form ref="formProfile" role="form">
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-text-field outlined dense v-model="name" :rules="nameRules" @focus="() => responseError.name=''" :error-messages="responseError.name" label="Nama Pelanggan"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-text-field @keypress="onlyNumber" outlined dense v-model="mobilephone" :rules="mobilephoneRules" @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone" label="Nomor Handphone"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-text-field @keypress="onlyNumber" outlined dense v-model="mobilephone2" :rules="mobilephoneRules2" @focus="() => responseError.mobilephone2=''" :error-messages="responseError.mobilephone2" label="Nomor Handphone 2 (optional)"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-text-field outlined dense v-model="email" :rules="emailRules" @focus="() => responseError.email=''" :error-messages="responseError.email" label="Email Pelanggan"></v-text-field>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="trx_method" :items="listSystemAvailable" item-text="text" item-value="value" label="Metode Transaksi" class="width-0" no-data-text="Tidak ada data tersedia" @focus="() => responseError.trx_method=''" :error-messages="responseError.trx_method"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete outlined dense v-model="trx_ecommerce" :items="optionEcommerce" item-text="text" item-value="value" label="Penjualan E-commerce" class="width-0" @focus="() => responseError.trx_ecommerce=''" :error-messages="responseError.trx_ecommerce"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-autocomplete :disabled="latest_customer_level == 'mb'" outlined dense v-model="customer_level" :items="['pramb', 'mb']" label="Tipe Pelanggan" class="width-0" @focus="() => responseError.customer_level=''" :error-messages="responseError.customer_level"></v-autocomplete>
							</v-col>
							<v-col cols="12" class="pb-0">
								<v-text-field outlined dense v-model="ktp" label="KTP" disabled></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			optionEcommerce: [
				{
					text: 'Ya',
					value: 'allowed'
				},
				{
					text: 'Tidak',
					value: 'unallowed'
				}
			],
			dialog: false,
			nameRules: [
			value => !!value || 'Nama tidak boleh kosong',
			],
			emailRules: [
			// value => !!value || 'Email tidak boleh kosong',
			value => {
				const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				const test = value ? re.test(String(value).toLowerCase()) : true
				return test || 'Email tidak valid';
			}
			],
			mobilephoneRules: [
			value => !!value || 'Nomor Handphone tidak boleh kosong',
			value => (value || '').length <= 14 && (value || '').length >= 10 && !isNaN(parseInt((value || ''))) || 'Nomor Handphone tidak valid',
			],
			mobilephoneRules2: [
			value => ((value || '').length <= 14 && (value || '').length >= 10 && !isNaN(parseInt((value || ''))) || !value) || 'Nomor Handphone tidak valid',
			],
			detailCustomer: {},
			name: '',
			mobilephone: '',
			mobilephone2: '',
			email: '',
			trx_method: '',
			trx_ecommerce: 0,
			ktp: '',
      latest_customer_level: '',
      customer_level: '',
		}
	},
	computed: {
		...mapState('customerList', ['responseError']),

		listSystemAvailable() {
			return this.listSystem.map(el => {
				let element = Object.assign({}, el)
				element.disabled = false
				if (this.detailCustomer.customer_trx_method != 'not_selected' && element.value == 'not_selected') {
					element.disabled = true
				}
				return element
			})
		}
	},
	props: {
		listSystem: {
			type: Array
		}
	},
	methods: {

		async showModal(data) {
			this.detailCustomer = data;
			this.name = await this.detailCustomer.customer_name
			this.mobilephone = await this.detailCustomer.customer_mobilephone
			this.mobilephone2 = await this.detailCustomer.customer_mobilephone2
			this.email = await this.detailCustomer.customer_email
			this.trx_method = await this.detailCustomer.customer_trx_method
			this.trx_ecommerce = await this.detailCustomer.customer_trx_ecommerce
			this.latest_customer_level = await this.detailCustomer.customer_level
			this.customer_level = await this.detailCustomer.customer_level
			this.ktp = await this.detailCustomer.customer_ktp
			this.dialog = await true
		},
		hideModal() {
			this.dialog = false
		},
		batal() {
			this.hideModal()
		},
		simpan() {
			if (this.$refs.formProfile.validate()) {
				let params = {
					id: this.detailCustomer.customer_id,
					network_id: this.detailCustomer.customer_network_id,
					network_mid: this.detailCustomer.customer_network_mid,
					network_code: this.detailCustomer.customer_network_code,
					name: this.name,
					email: this.email,
					mobilephone: this.mobilephone,
					mobilephone2: this.mobilephone2,
					province_id: this.detailCustomer.customer_province_id,
					province_name: this.detailCustomer.customer_province_name,
					city_id: this.detailCustomer.customer_city_id,
					city_name: this.detailCustomer.customer_city_name,
					subdistrict_id: this.detailCustomer.customer_subdistrict_id,
					subdistrict_name: this.detailCustomer.customer_subdistrict_name,
					address: this.detailCustomer.customer_address,
					latitude: this.detailCustomer.customer_latitude,
					longitude: this.detailCustomer.customer_longitude,
					level: this.detailCustomer.customer_level,
					trx_method: this.trx_method,
					trx_ecommerce: this.trx_ecommerce,
				}

        if (this.customer_level !== this.latest_customer_level) {
          params.customer_level = this.customer_level
        }
				this.$emit('action', params)
			}
		},
	},
}
</script>
